import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import MarkerMaps from './MarkerMaps';
import ResvTable from './ResvTable';
import Error from './Error';
import RegionHeader from './RegionHeader';
import ColorsContext from './ColorsContext';
import { getDefaultDate, setLongmonyr } from './routines';

function ResvRegion(props) {
	const monyr = props.date ? props.date : getDefaultDate();
	const [ markers, setMarkers ] = useState(null);
	const [ regionData, setRegionData ] = useState(null);
	const [ regionError, setRegionError ] = useState(false);
	const [ regionColors, setRegionColors ] = useState([]);
	const { levelColors } = useContext(ColorsContext);

	const selectedState = "ma"
	const ptDataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/station_li_coor.json";
	const rgDataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/regional_li_" + monyr + ".json";
	const longmonyr = setLongmonyr(monyr);
	const buttonValue = "listation";

	const getPointData = () => {
		let allmarkers = [];
		axios.get(ptDataFileName)
		.then(results => {
			Object.keys(results.data).forEach(region => {
				Object.keys(results.data[region]).forEach(sky => {
					const stn = results.data[region][sky]
					if (stn.position[0] !== null && stn.position[1] !== null) {
						allmarkers.push({
							position: stn.position, 
							fillColor: "darkgray", 
							data: [stn.name, ""]
						});
					}
				});
			});
			setMarkers(allmarkers);
		})
		.catch(err => {
			console.log("Point Data Error: " + err);
			setRegionError(true);
		});
	}

	const getRegionData = () => {
		axios.get(rgDataFileName)
		.then(results => {
			setRegionData(results.data.data);
			let allRegions = [];
			Object.keys(results.data.data).forEach(region => {
				const zone = results.data.data[region].zone
				allRegions[zone] = levelColors.plain;
			});
			setRegionColors(allRegions);
		})
		.catch(err => {
			console.log("Region Data Error: " + err);
			setRegionError(true);
		});
	}

	useEffect(() => {
		getPointData();
		getRegionData();
		setRegionError(false);
		 // eslint-disable-next-line
	}, [])

	return (
		<>
			<RegionHeader
				title={"Lakes/Impoundments Summary"}
				buttontext={"Table View"}
				buttonValue={buttonValue}
				handleButtonClick={props.handleButtonClick}
				addtext={"Data may be provisional."}
			/>
			{markers &&
				<div className="mapandlegend-container">
					<MarkerMaps 
						selectedState={selectedState} 
						markers={markers} 
						regionColors={regionColors}
						mapTitle={"Lakes/Impoundments Locations"}
					/>
				</div>
			}
			{regionData &&
				<>
					<ResvTable
						regionData={regionData}
						monyr={longmonyr}
					/>
					<div style={{textAlign:"center"}}>
						<p style={{fontSize:"90%", fontStyle:"italic"}}>
							Drought Management Plan index severity levels do not necessarily reflect water supply status. 
						</p>
					</div>

				</>
			}
			{regionError &&
				<>
					<Error />
				</>
			}
	   </>
	);
}

export default ResvRegion;